/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

class Incident {
    constructor() {
        this.requests = new Requests();
    }

    cancel = () => {
        this.requests.cancel();
    };

    getConfig = async (params = {}) => {
        try {
            const response = await axios.get('/incident/config', {
                cancelToken: this.requests.token(),
                params
            });

            if (!Response.hasResponse(response)) {
                debug.e('No Incident Config found');
                return false;
            }

            return response.data;
        } catch (e) {
            debug.e(e);
            return 0;
        }
    };
}

export default Incident;
